export default "__VITE_ASSET__DoIfCEL7__"